module.exports = __webpack_public_path__ + "img/banner.0d215ea6.jpg";